// AUTO-GENERATED por packages/contracts/scripts/generate-prisma-enums.mjs
// Origem: apps/backend/prisma/schema.prisma
// Nao editar manualmente. Para atualizar, rode: pnpm --filter @mediardex/contracts generate
export const AdministrationRoute = {
    ROUTE_ORAL: 'ROUTE_ORAL',
    ROUTE_SUBLINGUAL: 'ROUTE_SUBLINGUAL',
    ROUTE_INTRAVENOUS: 'ROUTE_INTRAVENOUS',
    ROUTE_INTRAMUSCULAR: 'ROUTE_INTRAMUSCULAR',
    ROUTE_SUBCUTANEOUS: 'ROUTE_SUBCUTANEOUS',
    ROUTE_INTRADERMAL: 'ROUTE_INTRADERMAL',
    ROUTE_TOPICAL: 'ROUTE_TOPICAL',
    ROUTE_RECTAL: 'ROUTE_RECTAL',
    ROUTE_VAGINAL: 'ROUTE_VAGINAL',
    ROUTE_OPHTHALMIC: 'ROUTE_OPHTHALMIC',
    ROUTE_OTIC: 'ROUTE_OTIC',
    ROUTE_NASAL: 'ROUTE_NASAL',
    ROUTE_INHALATION: 'ROUTE_INHALATION',
    ROUTE_ENTERAL: 'ROUTE_ENTERAL',
    ROUTE_PARENTERAL: 'ROUTE_PARENTERAL',
    ROUTE_OTHER: 'ROUTE_OTHER',
};
export const AdmissionStatus = {
    ADM_ACTIVE: 'ADM_ACTIVE',
    ADM_TRANSFERRED: 'ADM_TRANSFERRED',
    ADM_DISCHARGED: 'ADM_DISCHARGED',
    ADM_DEATH: 'ADM_DEATH',
    ADM_ESCAPED: 'ADM_ESCAPED',
    ADM_CANCELLED: 'ADM_CANCELLED',
};
export const AdPlatform = {
    META: 'META',
    GOOGLE: 'GOOGLE',
    TIKTOK: 'TIKTOK',
};
export const AgendaBlockType = {
    VACATION: 'VACATION',
    MEETING: 'MEETING',
    BREAK: 'BREAK',
    HOLIDAY: 'HOLIDAY',
    PERSONAL: 'PERSONAL',
    OTHER: 'OTHER',
};
export const AgendaEventStatus = {
    PENDING: 'PENDING',
    CONFIRMED: 'CONFIRMED',
    CANCELED: 'CANCELED',
    COMPLETED: 'COMPLETED',
    NO_SHOW: 'NO_SHOW',
    OVERDUE: 'OVERDUE',
    NO_SHOW_JUSTIFIED: 'NO_SHOW_JUSTIFIED',
    RESCHEDULED: 'RESCHEDULED',
};
export const AgendaEventType = {
    CONSULTATION: 'CONSULTATION',
    RETURN: 'RETURN',
    EXAM: 'EXAM',
    PROCEDURE: 'PROCEDURE',
    TELECONSULTATION: 'TELECONSULTATION',
    OTHER: 'OTHER',
    TASK_CALL: 'TASK_CALL',
    TASK_FOLLOW_UP: 'TASK_FOLLOW_UP',
    TASK_MEETING: 'TASK_MEETING',
    TASK_SEND_QUOTE: 'TASK_SEND_QUOTE',
    TASK_OTHER: 'TASK_OTHER',
};
export const AgendaType = {
    PERSONAL: 'PERSONAL',
    COMPANY: 'COMPANY',
    PROFESSIONAL: 'PROFESSIONAL',
    PARTNER: 'PARTNER',
};
export const AllergySeverity = {
    MILD: 'MILD',
    MODERATE: 'MODERATE',
    SEVERE: 'SEVERE',
    LIFE_THREATENING: 'LIFE_THREATENING',
};
export const AllergyStatus = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    RESOLVED: 'RESOLVED',
    REFUTED: 'REFUTED',
};
export const AllergyType = {
    MEDICATION: 'MEDICATION',
    FOOD: 'FOOD',
    ENVIRONMENTAL: 'ENVIRONMENTAL',
    INSECT: 'INSECT',
    LATEX: 'LATEX',
    CONTRAST: 'CONTRAST',
    OTHER: 'OTHER',
};
export const AppointmentType = {
    CONSULTATION: 'CONSULTATION',
    EXAM: 'EXAM',
    PROCEDURE: 'PROCEDURE',
};
export const AuthenticationType = {
    NONE: 'NONE',
    BASIC: 'BASIC',
    BEARER: 'BEARER',
    API_KEY: 'API_KEY',
    OAUTH2: 'OAUTH2',
    CLIENT_CREDENTIALS: 'CLIENT_CREDENTIALS',
    JWT: 'JWT',
};
export const AuthorizationStatus = {
    AUTH_DRAFT: 'AUTH_DRAFT',
    AUTH_PENDING_DOCS: 'AUTH_PENDING_DOCS',
    AUTH_READY_TO_SUBMIT: 'AUTH_READY_TO_SUBMIT',
    AUTH_SUBMITTED: 'AUTH_SUBMITTED',
    AUTH_IN_ANALYSIS: 'AUTH_IN_ANALYSIS',
    AUTH_PENDING_INFO: 'AUTH_PENDING_INFO',
    AUTH_AUTHORIZED: 'AUTH_AUTHORIZED',
    AUTH_PARTIALLY_AUTHORIZED: 'AUTH_PARTIALLY_AUTHORIZED',
    AUTH_DENIED: 'AUTH_DENIED',
    AUTH_EXPIRED: 'AUTH_EXPIRED',
    AUTH_CANCELLED: 'AUTH_CANCELLED',
};
export const AuthorizationUrgency = {
    AUTH_ROUTINE: 'AUTH_ROUTINE',
    AUTH_PRIORITY: 'AUTH_PRIORITY',
    AUTH_URGENT: 'AUTH_URGENT',
    AUTH_EMERGENCY: 'AUTH_EMERGENCY',
};
export const AutomationActionType = {
    SEND_WHATSAPP: 'SEND_WHATSAPP',
    SEND_WHATSAPP_TEMPLATE: 'SEND_WHATSAPP_TEMPLATE',
    SEND_EMAIL: 'SEND_EMAIL',
    SEND_NOTIFICATION: 'SEND_NOTIFICATION',
    CREATE_NOTE: 'CREATE_NOTE',
    ASSIGN_LEAD_TO_USER: 'ASSIGN_LEAD_TO_USER',
    ASSIGN_LEAD_TO_WALLET: 'ASSIGN_LEAD_TO_WALLET',
    ASSIGN_CLIENT_TO_WALLET: 'ASSIGN_CLIENT_TO_WALLET',
    MOVE_DEAL_STAGE: 'MOVE_DEAL_STAGE',
    UPDATE_LEAD_FIELD: 'UPDATE_LEAD_FIELD',
    UPDATE_DEAL_FIELD: 'UPDATE_DEAL_FIELD',
    ADD_TAG: 'ADD_TAG',
    REMOVE_TAG: 'REMOVE_TAG',
    CHANGE_LEAD_TEMPERATURE: 'CHANGE_LEAD_TEMPERATURE',
    CHANGE_LEAD_LIFECYCLE: 'CHANGE_LEAD_LIFECYCLE',
    CREATE_DEAL: 'CREATE_DEAL',
    START_FOLLOW_UP: 'START_FOLLOW_UP',
    WEBHOOK: 'WEBHOOK',
};
export const AutomationConditionLogic = {
    AND: 'AND',
    OR: 'OR',
};
export const AutomationTriggerEvent = {
    CHAT_STARTED: 'CHAT_STARTED',
    LEAD_CREATED: 'LEAD_CREATED',
    LEAD_UPDATED: 'LEAD_UPDATED',
    LEAD_ASSIGNED: 'LEAD_ASSIGNED',
    LEAD_SCORE_CHANGED: 'LEAD_SCORE_CHANGED',
    LEAD_SENTIMENT_CHANGED: 'LEAD_SENTIMENT_CHANGED',
    DEAL_SENTIMENT_CHANGED: 'DEAL_SENTIMENT_CHANGED',
    LEAD_CONVERTED: 'LEAD_CONVERTED',
    DEAL_CREATED: 'DEAL_CREATED',
    DEAL_STAGE_CHANGED: 'DEAL_STAGE_CHANGED',
    DEAL_CLOSED: 'DEAL_CLOSED',
    DEAL_VALUE_CHANGED: 'DEAL_VALUE_CHANGED',
    SLA_BREACHED: 'SLA_BREACHED',
    FOLLOW_UP_COMPLETED: 'FOLLOW_UP_COMPLETED',
    BILLING_CREATED: 'BILLING_CREATED',
    BILLING_PAID: 'BILLING_PAID',
    BILLING_ERROR: 'BILLING_ERROR',
    APPOINTMENT_CONFIRMED: 'APPOINTMENT_CONFIRMED',
    APPOINTMENT_PARTNER_CREATED: 'APPOINTMENT_PARTNER_CREATED',
    CONSULTATION_CREATED: 'CONSULTATION_CREATED',
    EXAM_CREATED: 'EXAM_CREATED',
    PROCEDURE_CREATED: 'PROCEDURE_CREATED',
    TELECONSULTATION_CREATED: 'TELECONSULTATION_CREATED',
    APPOINTMENT_MANUAL_CREATED: 'APPOINTMENT_MANUAL_CREATED',
    APPOINTMENT_MANUAL_PAID: 'APPOINTMENT_MANUAL_PAID',
    APPOINTMENT_MANUAL_BILLING_PENDING: 'APPOINTMENT_MANUAL_BILLING_PENDING',
};
export const BadgeRarity = {
    BRONZE: 'BRONZE',
    SILVER: 'SILVER',
    GOLD: 'GOLD',
    DIAMOND: 'DIAMOND',
};
export const BankAccountType = {
    CHECKING: 'CHECKING',
    SAVINGS: 'SAVINGS',
};
export const BatchStatus = {
    BATCH_ACTIVE: 'BATCH_ACTIVE',
    BATCH_QUARANTINE: 'BATCH_QUARANTINE',
    BATCH_EXPIRED: 'BATCH_EXPIRED',
    BATCH_RECALLED: 'BATCH_RECALLED',
    BATCH_DEPLETED: 'BATCH_DEPLETED',
    BATCH_BLOCKED: 'BATCH_BLOCKED',
};
export const BedStatus = {
    AVAILABLE: 'AVAILABLE',
    OCCUPIED: 'OCCUPIED',
    RESERVED: 'RESERVED',
    CLEANING: 'CLEANING',
    MAINTENANCE: 'MAINTENANCE',
    BLOCKED: 'BLOCKED',
    INTERDICTED: 'INTERDICTED',
};
export const BedType = {
    STANDARD: 'STANDARD',
    ELECTRIC: 'ELECTRIC',
    PEDIATRIC: 'PEDIATRIC',
    BARIATRIC: 'BARIATRIC',
    STRETCHER: 'STRETCHER',
    CRIB: 'CRIB',
    INCUBATOR: 'INCUBATOR',
    OTHER_BED: 'OTHER_BED',
};
export const BillingActionStatus = {
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
};
export const BillingActionType = {
    MARK_PAID: 'MARK_PAID',
    CANCEL: 'CANCEL',
    REFUND: 'REFUND',
    SETTLE_PROCEDURE: 'SETTLE_PROCEDURE',
};
export const BillingApprovalStatus = {
    NOT_REQUIRED: 'NOT_REQUIRED',
    PENDING_APPROVAL: 'PENDING_APPROVAL',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
};
export const BillingBatchStatus = {
    BATCH_OPEN: 'BATCH_OPEN',
    BATCH_CLOSED: 'BATCH_CLOSED',
    BATCH_SUBMITTED: 'BATCH_SUBMITTED',
    BATCH_PROCESSING: 'BATCH_PROCESSING',
    BATCH_PROCESSED: 'BATCH_PROCESSED',
    BATCH_PARTIAL_RETURN: 'BATCH_PARTIAL_RETURN',
    BATCH_COMPLETED: 'BATCH_COMPLETED',
};
export const BillingPayerType = {
    CLIENT: 'CLIENT',
    HEALTH_PLAN: 'HEALTH_PLAN',
};
export const BillingPaymentMethod = {
    PIX: 'PIX',
    BOLETO: 'BOLETO',
    CREDIT_CARD: 'CREDIT_CARD',
    DEBIT_CARD: 'DEBIT_CARD',
    CASH: 'CASH',
    BANK_TRANSFER: 'BANK_TRANSFER',
    CHECK: 'CHECK',
    TERMINAL: 'TERMINAL',
    OTHER: 'OTHER',
};
export const BillingStatus = {
    PENDING: 'PENDING',
    PAID: 'PAID',
    OVERDUE: 'OVERDUE',
    CANCELLED: 'CANCELLED',
    REFUNDED: 'REFUNDED',
    PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED',
    PARTIALLY_PAID: 'PARTIALLY_PAID',
    IN_DISPUTE: 'IN_DISPUTE',
    WRITTEN_OFF: 'WRITTEN_OFF',
};
export const BillingType = {
    RECEIVABLE: 'RECEIVABLE',
    PAYABLE: 'PAYABLE',
};
export const BloodType = {
    A_POSITIVE: 'A_POSITIVE',
    A_NEGATIVE: 'A_NEGATIVE',
    B_POSITIVE: 'B_POSITIVE',
    B_NEGATIVE: 'B_NEGATIVE',
    AB_POSITIVE: 'AB_POSITIVE',
    AB_NEGATIVE: 'AB_NEGATIVE',
    O_POSITIVE: 'O_POSITIVE',
    O_NEGATIVE: 'O_NEGATIVE',
    UNKNOWN: 'UNKNOWN',
};
export const CampaignConversionType = {
    LEAD: 'LEAD',
    APPOINTMENT: 'APPOINTMENT',
    BILLING_PAID: 'BILLING_PAID',
    CLIENT_SIGNUP: 'CLIENT_SIGNUP',
};
export const CampaignDestinationType = {
    WHATSAPP: 'WHATSAPP',
    URL: 'URL',
    WHATSAPP_WITH_MESSAGE: 'WHATSAPP_WITH_MESSAGE',
};
export const CampaignStatus = {
    DRAFT: 'DRAFT',
    ACTIVE: 'ACTIVE',
    PAUSED: 'PAUSED',
    FINISHED: 'FINISHED',
};
export const CashRegisterDirection = {
    IN: 'IN',
    OUT: 'OUT',
};
export const CashRegisterEntrySource = {
    AUTO: 'AUTO',
    MANUAL: 'MANUAL',
};
export const CatalogCategory = {
    EXAM: 'EXAM',
    PROCEDURE: 'PROCEDURE',
    CONSULTATION: 'CONSULTATION',
    TELECONSULTATION: 'TELECONSULTATION',
    PACKAGE: 'PACKAGE',
    PRODUCT: 'PRODUCT',
};
export const CatalogStockMovementReason = {
    PURCHASE: 'PURCHASE',
    ADJUSTMENT: 'ADJUSTMENT',
    INVENTORY: 'INVENTORY',
    SALE_STORE: 'SALE_STORE',
    SALE_ORDER: 'SALE_ORDER',
    RETURN: 'RETURN',
    LOSS: 'LOSS',
};
export const CatalogStockMovementType = {
    IN: 'IN',
    OUT: 'OUT',
};
export const CertificateStatus = {
    CERTIFICATE_ACTIVE: 'CERTIFICATE_ACTIVE',
    CERTIFICATE_EXPIRED: 'CERTIFICATE_EXPIRED',
    CERTIFICATE_REVOKED: 'CERTIFICATE_REVOKED',
    CERTIFICATE_SUSPENDED: 'CERTIFICATE_SUSPENDED',
};
export const CertificateType = {
    ICP_BRASIL: 'ICP_BRASIL',
    CFM: 'CFM',
};
export const ChartOfAccountsType = {
    ASSET: 'ASSET',
    LIABILITY: 'LIABILITY',
    EQUITY: 'EQUITY',
    INCOME: 'INCOME',
    EXPENSE: 'EXPENSE',
};
export const ChatAiInstructionsMode = {
    NEXT_REPLY: 'NEXT_REPLY',
    UNTIL_TIME: 'UNTIL_TIME',
    PERMANENT: 'PERMANENT',
};
export const ChatAutoCloseMode = {
    WINDOW: 'WINDOW',
    HOURS: 'HOURS',
    NEVER: 'NEVER',
};
export const ChatChannel = {
    WHATSAPP: 'WHATSAPP',
    INSTAGRAM: 'INSTAGRAM',
    MESSENGER: 'MESSENGER',
};
export const ChatInitiatedMode = {
    TEXT: 'TEXT',
    VOICE: 'VOICE',
    VIDEO: 'VIDEO',
};
export const ChatSenderType = {
    CLIENT: 'CLIENT',
    AI: 'AI',
    TEAM: 'TEAM',
    AUTOMATION: 'AUTOMATION',
};
export const ChatStatus = {
    OPEN: 'OPEN',
    CLOSED: 'CLOSED',
};
export const CheckStatus = {
    CHECK_PENDING: 'CHECK_PENDING',
    CHECK_ADMINISTERED: 'CHECK_ADMINISTERED',
    CHECK_NOT_ADMINISTERED: 'CHECK_NOT_ADMINISTERED',
    CHECK_DELAYED: 'CHECK_DELAYED',
    CHECK_REFUSED: 'CHECK_REFUSED',
    CHECK_SUSPENDED: 'CHECK_SUSPENDED',
};
export const CleaningStatus = {
    CLEAN_PENDING: 'CLEAN_PENDING',
    CLEAN_IN_PROGRESS: 'CLEAN_IN_PROGRESS',
    CLEAN_COMPLETED: 'CLEAN_COMPLETED',
    CLEAN_VERIFIED: 'CLEAN_VERIFIED',
};
export const CleaningType = {
    CONCURRENT: 'CONCURRENT',
    TERMINAL: 'TERMINAL',
    IMMEDIATE: 'IMMEDIATE',
};
export const CompanySecondarySegment = {
    INTERMEDIATION: 'INTERMEDIATION',
    OTHER: 'OTHER',
};
export const CompanySegment = {
    HEALTH: 'HEALTH',
    BEAUTY: 'BEAUTY',
    FITNESS: 'FITNESS',
    PET_SHOP: 'PET_SHOP',
    DIRECT_SALE: 'DIRECT_SALE',
    QUOTE_BASED_SALE: 'QUOTE_BASED_SALE',
    OTHER: 'OTHER',
};
export const ConditionStatus = {
    ACTIVE: 'ACTIVE',
    CONTROLLED: 'CONTROLLED',
    RESOLVED: 'RESOLVED',
    IN_REMISSION: 'IN_REMISSION',
};
export const ConsentType = {
    GENERAL_TREATMENT: 'GENERAL_TREATMENT',
    SURGICAL_PROCEDURE: 'SURGICAL_PROCEDURE',
    ANESTHESIA: 'ANESTHESIA',
    BLOOD_TRANSFUSION: 'BLOOD_TRANSFUSION',
    CLINICAL_TRIAL: 'CLINICAL_TRIAL',
    DATA_SHARING: 'DATA_SHARING',
    TELEMEDICINE: 'TELEMEDICINE',
    IMAGING: 'IMAGING',
    INVASIVE_PROCEDURE: 'INVASIVE_PROCEDURE',
    CONSENT_OTHER: 'CONSENT_OTHER',
};
export const ConsultationStatus = {
    REQUESTED: 'REQUESTED',
    SCHEDULED: 'SCHEDULED',
    WAITING: 'WAITING',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
    NO_SHOW: 'NO_SHOW',
};
export const ContractCreatedByType = {
    COMPANY: 'COMPANY',
    PARTNER: 'PARTNER',
};
export const ContractStatus = {
    DRAFT: 'DRAFT',
    IN_ANALYSIS: 'IN_ANALYSIS',
    SENT: 'SENT',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
    SIGNED: 'SIGNED',
};
export const ContractTermsStatus = {
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
    PENDING: 'PENDING',
};
export const ContractTermsType = {
    CLAUSE: 'CLAUSE',
    PARAGRAPH: 'PARAGRAPH',
    INCISO: 'INCISO',
    ALINEA: 'ALINEA',
    HEADER: 'HEADER',
    FOOTER: 'FOOTER',
};
export const CoparticipationType = {
    COPART_PERCENTAGE: 'COPART_PERCENTAGE',
    COPART_FIXED: 'COPART_FIXED',
    COPART_MIXED: 'COPART_MIXED',
    COPART_CEILING: 'COPART_CEILING',
    COPART_DEDUCTIBLE: 'COPART_DEDUCTIBLE',
};
export const DealStatus = {
    OPEN: 'OPEN',
    WON: 'WON',
    LOST: 'LOST',
    ABANDONED: 'ABANDONED',
};
export const DepartmentAiResumeMode = {
    BACKUP: 'BACKUP',
    TAKEOVER: 'TAKEOVER',
};
export const DiagnosisCertainty = {
    CONFIRMED: 'CONFIRMED',
    PROVISIONAL: 'PROVISIONAL',
    DIFFERENTIAL: 'DIFFERENTIAL',
    RULED_OUT: 'RULED_OUT',
};
export const DiagnosisStatus = {
    DIAGNOSIS_ACTIVE: 'DIAGNOSIS_ACTIVE',
    DIAGNOSIS_RESOLVED: 'DIAGNOSIS_RESOLVED',
    DIAGNOSIS_IN_REMISSION: 'DIAGNOSIS_IN_REMISSION',
    CHRONIC: 'CHRONIC',
};
export const DiagnosisType = {
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    ADMISSION: 'ADMISSION',
    DISCHARGE: 'DISCHARGE',
};
export const DicomModality = {
    CR: 'CR',
    CT: 'CT',
    MR: 'MR',
    US: 'US',
    XA: 'XA',
    NM: 'NM',
    PT: 'PT',
    DX: 'DX',
    MG: 'MG',
    OT: 'OT',
};
export const DischargeStatus = {
    DISCH_PENDING: 'DISCH_PENDING',
    DISCH_IN_PROGRESS: 'DISCH_IN_PROGRESS',
    DISCH_AWAITING_APPROVAL: 'DISCH_AWAITING_APPROVAL',
    DISCH_APPROVED: 'DISCH_APPROVED',
    DISCH_COMPLETED: 'DISCH_COMPLETED',
    DISCH_CANCELLED: 'DISCH_CANCELLED',
};
export const DischargeType = {
    DISCHARGE_MEDICAL: 'DISCHARGE_MEDICAL',
    DISCHARGE_REQUEST: 'DISCHARGE_REQUEST',
    DISCHARGE_TRANSFER: 'DISCHARGE_TRANSFER',
    DISCHARGE_DEATH: 'DISCHARGE_DEATH',
    DISCHARGE_ESCAPE: 'DISCHARGE_ESCAPE',
    DISCHARGE_ADMINISTRATIVE: 'DISCHARGE_ADMINISTRATIVE',
};
export const DiscountType = {
    PERCENTAGE: 'PERCENTAGE',
    FIXED_AMOUNT: 'FIXED_AMOUNT',
};
export const DispensationStatus = {
    DISP_PENDING: 'DISP_PENDING',
    DISP_SEPARATED: 'DISP_SEPARATED',
    DISP_CHECKED: 'DISP_CHECKED',
    DISP_DISPENSED: 'DISP_DISPENSED',
    DISP_PARTIALLY_DISPENSED: 'DISP_PARTIALLY_DISPENSED',
    DISP_CANCELLED: 'DISP_CANCELLED',
    DISP_RETURNED: 'DISP_RETURNED',
};
export const DocumentSignerStatus = {
    WAITING: 'WAITING',
    SIGNED: 'SIGNED',
};
export const DocumentSignerType = {
    PARTNER: 'PARTNER',
    CLIENT: 'CLIENT',
    OTHER: 'OTHER',
};
export const DocumentType = {
    CPF: 'CPF',
    CNPJ: 'CNPJ',
};
export const ElectronicPrescriptionStatus = {
    PRESCRIPTION_CREATED: 'PRESCRIPTION_CREATED',
    PRESCRIPTION_SIGNED: 'PRESCRIPTION_SIGNED',
    PRESCRIPTION_SENT: 'PRESCRIPTION_SENT',
    PRESCRIPTION_VIEWED: 'PRESCRIPTION_VIEWED',
    PRESCRIPTION_PARTIALLY_DISPENSED: 'PRESCRIPTION_PARTIALLY_DISPENSED',
    PRESCRIPTION_DISPENSED: 'PRESCRIPTION_DISPENSED',
    PRESCRIPTION_CANCELLED: 'PRESCRIPTION_CANCELLED',
    PRESCRIPTION_EXPIRED: 'PRESCRIPTION_EXPIRED',
};
export const EmailAccountProvider = {
    GMAIL: 'GMAIL',
};
export const EmailAccountStatus = {
    ACTIVE: 'ACTIVE',
    DISCONNECTED: 'DISCONNECTED',
    ERROR: 'ERROR',
};
export const EsocialEnvironment = {
    PRODUCTION: 'PRODUCTION',
    RESTRICTED: 'RESTRICTED',
};
export const EsocialEventStatus = {
    PENDING: 'PENDING',
    SIGNED: 'SIGNED',
    SENT: 'SENT',
    ACCEPTED: 'ACCEPTED',
    REJECTED: 'REJECTED',
    PROCESSING: 'PROCESSING',
};
export const EstablishmentType = {
    CLINIC: 'CLINIC',
    HOSPITAL: 'HOSPITAL',
    GYM: 'GYM',
    LABORATORY: 'LABORATORY',
    PHARMACY: 'PHARMACY',
    REHABILITATION_CENTER: 'REHABILITATION_CENTER',
    SPA: 'SPA',
    DENTAL_CLINIC: 'DENTAL_CLINIC',
    VETERINARY: 'VETERINARY',
    OTHER: 'OTHER',
};
export const EstimatedTimeUnit = {
    MINUTES: 'MINUTES',
    HOURS: 'HOURS',
    DAYS: 'DAYS',
};
export const ExamStatus = {
    BUDGET: 'BUDGET',
    REQUESTED: 'REQUESTED',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
};
export const FamilyRelationship = {
    FATHER: 'FATHER',
    MOTHER: 'MOTHER',
    PATERNAL_GRANDFATHER: 'PATERNAL_GRANDFATHER',
    PATERNAL_GRANDMOTHER: 'PATERNAL_GRANDMOTHER',
    MATERNAL_GRANDFATHER: 'MATERNAL_GRANDFATHER',
    MATERNAL_GRANDMOTHER: 'MATERNAL_GRANDMOTHER',
    BROTHER: 'BROTHER',
    SISTER: 'SISTER',
    SON: 'SON',
    DAUGHTER: 'DAUGHTER',
    UNCLE: 'UNCLE',
    AUNT: 'AUNT',
    COUSIN: 'COUSIN',
    OTHER: 'OTHER',
};
export const FinancialCategoryType = {
    INCOME: 'INCOME',
    EXPENSE: 'EXPENSE',
    BOTH: 'BOTH',
};
export const FinancialTransferDestinationType = {
    BANK_ACCOUNT: 'BANK_ACCOUNT',
    PIX: 'PIX',
    PARTNER: 'PARTNER',
    PROFESSIONAL: 'PROFESSIONAL',
    SUPPLIER: 'SUPPLIER',
    ORG_OWN_BANK: 'ORG_OWN_BANK',
    PLATFORM_ACCOUNT: 'PLATFORM_ACCOUNT',
};
export const FinancialTransferKind = {
    STANDALONE: 'STANDALONE',
    BILLING_PAYMENT: 'BILLING_PAYMENT',
};
export const FinancialTransferStatus = {
    PENDING_APPROVAL: 'PENDING_APPROVAL',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
    PROCESSING: 'PROCESSING',
    DONE: 'DONE',
    FAILED: 'FAILED',
    CANCELLED: 'CANCELLED',
};
export const FiscalNoteStatus = {
    PENDING: 'PENDING',
    PROCESSING: 'PROCESSING',
    AUTHORIZED: 'AUTHORIZED',
    DENIED: 'DENIED',
    CANCELLED: 'CANCELLED',
    ERROR: 'ERROR',
};
export const FiscalNoteType = {
    NFE: 'NFE',
    NFSE: 'NFSE',
};
export const FluidType = {
    INTAKE: 'INTAKE',
    OUTPUT: 'OUTPUT',
};
export const FollowUpChannel = {
    WHATSAPP: 'WHATSAPP',
    WHATSAPP_TEMPLATE: 'WHATSAPP_TEMPLATE',
    EMAIL: 'EMAIL',
    NOTIFICATION: 'NOTIFICATION',
    INTERNAL_NOTE: 'INTERNAL_NOTE',
};
export const FollowUpConditionField = {
    LEAD_REPLIED: 'LEAD_REPLIED',
    LEAD_SENTIMENT: 'LEAD_SENTIMENT',
    LEAD_TEMPERATURE: 'LEAD_TEMPERATURE',
    LEAD_SCORE: 'LEAD_SCORE',
    DEAL_STATUS: 'DEAL_STATUS',
    DEAL_VALUE: 'DEAL_VALUE',
    DEAL_SENTIMENT: 'DEAL_SENTIMENT',
    CUSTOM_FIELD: 'CUSTOM_FIELD',
};
export const FollowUpConditionOperator = {
    EQUALS: 'EQUALS',
    NOT_EQUALS: 'NOT_EQUALS',
    GREATER_THAN: 'GREATER_THAN',
    LESS_THAN: 'LESS_THAN',
    IN: 'IN',
    NOT_IN: 'NOT_IN',
    EXISTS: 'EXISTS',
    NOT_EXISTS: 'NOT_EXISTS',
    CONTEXT_MATCH: 'CONTEXT_MATCH',
};
export const FollowUpExecutionStatus = {
    ACTIVE: 'ACTIVE',
    PAUSED: 'PAUSED',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
    FAILED: 'FAILED',
};
export const FollowUpStepLogStatus = {
    SENT: 'SENT',
    SKIPPED: 'SKIPPED',
    FAILED: 'FAILED',
    PENDING: 'PENDING',
};
export const FollowUpStepType = {
    ACTION: 'ACTION',
    CONDITION: 'CONDITION',
    DELAY: 'DELAY',
};
export const FollowUpTriggerType = {
    MANUAL: 'MANUAL',
    STAGE_CHANGE: 'STAGE_CHANGE',
    SENTIMENT_CHANGE: 'SENTIMENT_CHANGE',
    LEAD_CREATED: 'LEAD_CREATED',
    DEAL_CREATED: 'DEAL_CREATED',
    DEAL_CLOSED: 'DEAL_CLOSED',
};
export const Gender = {
    MALE: 'MALE',
    FEMALE: 'FEMALE',
    OTHER: 'OTHER',
    PREFER_NOT_TO_SAY: 'PREFER_NOT_TO_SAY',
};
export const GlossStatus = {
    GLOSS_IDENTIFIED: 'GLOSS_IDENTIFIED',
    GLOSS_PENDING_ANALYSIS: 'GLOSS_PENDING_ANALYSIS',
    GLOSS_ACCEPTED: 'GLOSS_ACCEPTED',
    GLOSS_APPEALING: 'GLOSS_APPEALING',
    GLOSS_APPEAL_SUBMITTED: 'GLOSS_APPEAL_SUBMITTED',
    GLOSS_APPEAL_ACCEPTED: 'GLOSS_APPEAL_ACCEPTED',
    GLOSS_APPEAL_DENIED: 'GLOSS_APPEAL_DENIED',
    GLOSS_PARTIAL_RECOVERY: 'GLOSS_PARTIAL_RECOVERY',
    GLOSS_WRITTEN_OFF: 'GLOSS_WRITTEN_OFF',
};
export const GlossType = {
    GLOSS_ADMINISTRATIVE: 'GLOSS_ADMINISTRATIVE',
    GLOSS_TECHNICAL: 'GLOSS_TECHNICAL',
    GLOSS_LINEAR_DISCOUNT: 'GLOSS_LINEAR_DISCOUNT',
    GLOSS_PROCEDURAL: 'GLOSS_PROCEDURAL',
};
export const GoogleAdsConnectionStatus = {
    PENDING: 'PENDING',
    ACTIVE: 'ACTIVE',
    EXPIRED: 'EXPIRED',
    REVOKED: 'REVOKED',
};
export const GuideOrigin = {
    GUIDE_MANUAL: 'GUIDE_MANUAL',
    GUIDE_CONSULTATION: 'GUIDE_CONSULTATION',
    GUIDE_PROCEDURE: 'GUIDE_PROCEDURE',
    GUIDE_EXAM: 'GUIDE_EXAM',
    GUIDE_HOSPITALIZATION: 'GUIDE_HOSPITALIZATION',
    GUIDE_BATCH: 'GUIDE_BATCH',
};
export const GuideStatus = {
    GUIDE_DRAFT: 'GUIDE_DRAFT',
    GUIDE_PENDING_AUTHORIZATION: 'GUIDE_PENDING_AUTHORIZATION',
    GUIDE_AUTHORIZED: 'GUIDE_AUTHORIZED',
    GUIDE_PARTIALLY_AUTHORIZED: 'GUIDE_PARTIALLY_AUTHORIZED',
    GUIDE_DENIED: 'GUIDE_DENIED',
    GUIDE_PENDING_SUBMISSION: 'GUIDE_PENDING_SUBMISSION',
    GUIDE_SUBMITTED: 'GUIDE_SUBMITTED',
    GUIDE_PROCESSED: 'GUIDE_PROCESSED',
    GUIDE_GLOSS: 'GUIDE_GLOSS',
    GUIDE_PAID: 'GUIDE_PAID',
    GUIDE_CANCELLED: 'GUIDE_CANCELLED',
};
export const HealthMapFilledBy = {
    PROFESSIONAL: 'PROFESSIONAL',
    PATIENT: 'PATIENT',
};
export const HealthMapQuestionType = {
    YES_NO: 'YES_NO',
    TEXT: 'TEXT',
    MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
    SINGLE_CHOICE: 'SINGLE_CHOICE',
};
export const HealthMapResponseStatus = {
    DRAFT: 'DRAFT',
    COMPLETED: 'COMPLETED',
};
export const HealthPlanSettlementMode = {
    DIRECT_INVOICE: 'DIRECT_INVOICE',
    TISS_BATCH: 'TISS_BATCH',
};
export const HelpTicketPriority = {
    LOW: 'LOW',
    NORMAL: 'NORMAL',
    HIGH: 'HIGH',
    URGENT: 'URGENT',
};
export const HelpTicketStatus = {
    OPEN: 'OPEN',
    IN_PROGRESS: 'IN_PROGRESS',
    ANSWERED: 'ANSWERED',
    RESOLVED: 'RESOLVED',
    CLOSED: 'CLOSED',
};
export const HospitalPrescriptionStatus = {
    HOSP_PRESC_DRAFT: 'HOSP_PRESC_DRAFT',
    HOSP_PRESC_ACTIVE: 'HOSP_PRESC_ACTIVE',
    HOSP_PRESC_SUSPENDED: 'HOSP_PRESC_SUSPENDED',
    HOSP_PRESC_COMPLETED: 'HOSP_PRESC_COMPLETED',
    HOSP_PRESC_CANCELLED: 'HOSP_PRESC_CANCELLED',
};
export const HospitalUnitType = {
    WARD: 'WARD',
    SEMI_INTENSIVE: 'SEMI_INTENSIVE',
    ICU: 'ICU',
    NEONATAL_ICU: 'NEONATAL_ICU',
    PEDIATRIC_ICU: 'PEDIATRIC_ICU',
    CARDIAC_ICU: 'CARDIAC_ICU',
    EMERGENCY: 'EMERGENCY',
    SURGICAL_CENTER: 'SURGICAL_CENTER',
    RECOVERY: 'RECOVERY',
    MATERNITY: 'MATERNITY',
    PSYCHIATRY: 'PSYCHIATRY',
    ISOLATION: 'ISOLATION',
    DAY_HOSPITAL: 'DAY_HOSPITAL',
    OTHER: 'OTHER',
};
export const HrBankAccountType = {
    CHECKING: 'CHECKING',
    SAVINGS: 'SAVINGS',
    SALARY: 'SALARY',
};
export const HrChangeType = {
    ADMISSION: 'ADMISSION',
    PROMOTION: 'PROMOTION',
    SALARY_CHANGE: 'SALARY_CHANGE',
    TRANSFER: 'TRANSFER',
    TERMINATION: 'TERMINATION',
    CONTRACT_CHANGE: 'CONTRACT_CHANGE',
    DEPARTMENT_CHANGE: 'DEPARTMENT_CHANGE',
};
export const HrContractType = {
    CLT: 'CLT',
    TEMPORARY: 'TEMPORARY',
    INTERMITTENT: 'INTERMITTENT',
    APPRENTICE: 'APPRENTICE',
    INTERN: 'INTERN',
};
export const HrDependentRelationship = {
    SPOUSE: 'SPOUSE',
    CHILD: 'CHILD',
    PARENT: 'PARENT',
    OTHER: 'OTHER',
};
export const HrEmployeeStatus = {
    ACTIVE: 'ACTIVE',
    ON_LEAVE: 'ON_LEAVE',
    SUSPENDED: 'SUSPENDED',
    TERMINATED: 'TERMINATED',
};
export const HrGender = {
    MALE: 'MALE',
    FEMALE: 'FEMALE',
    OTHER: 'OTHER',
};
export const HrHourBankEntryType = {
    CREDIT: 'CREDIT',
    DEBIT: 'DEBIT',
};
export const HrMaritalStatus = {
    SINGLE: 'SINGLE',
    MARRIED: 'MARRIED',
    DIVORCED: 'DIVORCED',
    WIDOWED: 'WIDOWED',
    SEPARATED: 'SEPARATED',
    STABLE_UNION: 'STABLE_UNION',
};
export const HrPayrollItemDetailType = {
    EARNING: 'EARNING',
    DEDUCTION: 'DEDUCTION',
};
export const HrPayrollRunOrigin = {
    SYSTEM: 'SYSTEM',
    IMPORTED: 'IMPORTED',
};
export const HrPayrollRunStatus = {
    DRAFT: 'DRAFT',
    CALCULATING: 'CALCULATING',
    CALCULATED: 'CALCULATED',
    APPROVED: 'APPROVED',
    PAID: 'PAID',
    CANCELLED: 'CANCELLED',
};
export const HrPayrollRunType = {
    MONTHLY: 'MONTHLY',
    ADVANCE: 'ADVANCE',
    THIRTEENTH_1ST: 'THIRTEENTH_1ST',
    THIRTEENTH_2ND: 'THIRTEENTH_2ND',
    VACATION: 'VACATION',
    TERMINATION: 'TERMINATION',
    COMPLEMENTARY: 'COMPLEMENTARY',
};
export const HrPayrollTableType = {
    INSS: 'INSS',
    IRRF: 'IRRF',
    MINIMUM_WAGE: 'MINIMUM_WAGE',
    FAMILY_SALARY: 'FAMILY_SALARY',
};
export const HrPixKeyType = {
    CPF: 'CPF',
    CNPJ: 'CNPJ',
    EMAIL: 'EMAIL',
    PHONE: 'PHONE',
    RANDOM: 'RANDOM',
};
export const HrRace = {
    WHITE: 'WHITE',
    BLACK: 'BLACK',
    BROWN: 'BROWN',
    ASIAN: 'ASIAN',
    INDIGENOUS: 'INDIGENOUS',
    NOT_DECLARED: 'NOT_DECLARED',
};
export const HrRubricCalcType = {
    FIXED: 'FIXED',
    PERCENTAGE: 'PERCENTAGE',
    FORMULA: 'FORMULA',
    TABLE: 'TABLE',
};
export const HrRubricType = {
    EARNING: 'EARNING',
    DEDUCTION: 'DEDUCTION',
    INFORMATIONAL: 'INFORMATIONAL',
};
export const HrSalaryType = {
    MONTHLY: 'MONTHLY',
    HOURLY: 'HOURLY',
    COMMISSION: 'COMMISSION',
};
export const HrTerminationType = {
    WITHOUT_CAUSE: 'WITHOUT_CAUSE',
    WITH_CAUSE: 'WITH_CAUSE',
    VOLUNTARY: 'VOLUNTARY',
    MUTUAL_AGREEMENT: 'MUTUAL_AGREEMENT',
    END_OF_CONTRACT: 'END_OF_CONTRACT',
    DEATH: 'DEATH',
};
export const HrTimeEntryType = {
    CLOCK_IN: 'CLOCK_IN',
    BREAK_OUT: 'BREAK_OUT',
    BREAK_IN: 'BREAK_IN',
    CLOCK_OUT: 'CLOCK_OUT',
};
export const HrTimeSheetStatus = {
    OPEN: 'OPEN',
    CLOSED: 'CLOSED',
    APPROVED: 'APPROVED',
};
export const HrVacationStatus = {
    SCHEDULED: 'SCHEDULED',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
};
export const HrWorkRegime = {
    ONSITE: 'ONSITE',
    REMOTE: 'REMOTE',
    HYBRID: 'HYBRID',
};
export const IcdVersion = {
    ICD_10: 'ICD_10',
    ICD_11: 'ICD_11',
};
export const IntakeSource = {
    INTAKE_ORAL: 'INTAKE_ORAL',
    INTAKE_IV_FLUID: 'INTAKE_IV_FLUID',
    INTAKE_IV_MEDICATION: 'INTAKE_IV_MEDICATION',
    INTAKE_BLOOD_PRODUCT: 'INTAKE_BLOOD_PRODUCT',
    INTAKE_ENTERAL: 'INTAKE_ENTERAL',
    INTAKE_PARENTERAL: 'INTAKE_PARENTERAL',
    INTAKE_OTHER: 'INTAKE_OTHER',
};
export const InternalConversationType = {
    PRIVATE: 'PRIVATE',
    BROADCAST_TYPE: 'BROADCAST_TYPE',
    BROADCAST_ALL: 'BROADCAST_ALL',
    AI_CHAT: 'AI_CHAT',
};
export const InternalMessageStatus = {
    SENT: 'SENT',
    DELIVERED: 'DELIVERED',
    PARTIALLY_READ: 'PARTIALLY_READ',
    READ: 'READ',
};
export const JournalEntryLineType = {
    DEBIT: 'DEBIT',
    CREDIT: 'CREDIT',
};
export const JournalEntryOrigin = {
    AUTOMATIC: 'AUTOMATIC',
    AI_CLASSIFIED: 'AI_CLASSIFIED',
    MANUAL: 'MANUAL',
};
export const JournalEntryStatus = {
    PENDING: 'PENDING',
    POSTED: 'POSTED',
    REVIEWED: 'REVIEWED',
};
export const LabIntegrationProtocol = {
    HL7_V2: 'HL7_V2',
    FHIR_R4: 'FHIR_R4',
    REST_API: 'REST_API',
    FILE_IMPORT: 'FILE_IMPORT',
};
export const LabMessageStatus = {
    PENDING: 'PENDING',
    PROCESSING: 'PROCESSING',
    PROCESSED: 'PROCESSED',
    FAILED: 'FAILED',
};
export const LabMessageType = {
    ADT: 'ADT',
    ORM: 'ORM',
    ORU: 'ORU',
    ACK: 'ACK',
};
export const LeadLifecycleStatus = {
    NEW: 'NEW',
    CONTACTING: 'CONTACTING',
    MQL: 'MQL',
    SAL: 'SAL',
    SQL: 'SQL',
    PROPOSAL: 'PROPOSAL',
    NEGOTIATION: 'NEGOTIATION',
    CONVERTED: 'CONVERTED',
    INACTIVE: 'INACTIVE',
    LOST: 'LOST',
};
export const LeadSentimentType = {
    INTERESTED: 'INTERESTED',
    VERY_SATISFIED: 'VERY_SATISFIED',
    SATISFIED: 'SATISFIED',
    NEUTRAL: 'NEUTRAL',
    CURIOUS: 'CURIOUS',
    HESITANT: 'HESITANT',
    DISSATISFIED: 'DISSATISFIED',
    FRUSTRATED: 'FRUSTRATED',
    ANGRY: 'ANGRY',
    URGENT: 'URGENT',
};
export const LeadSource = {
    WHATSAPP: 'WHATSAPP',
    INSTAGRAM: 'INSTAGRAM',
    MESSENGER: 'MESSENGER',
    MANUAL: 'MANUAL',
    WEBSITE: 'WEBSITE',
    REFERRAL: 'REFERRAL',
    CAMPAIGN: 'CAMPAIGN',
    UTM: 'UTM',
    SOCIAL_MEDIA: 'SOCIAL_MEDIA',
    PHONE: 'PHONE',
    EMAIL: 'EMAIL',
    PARTNER: 'PARTNER',
    OTHER: 'OTHER',
};
export const LeadStatus = {
    NEW: 'NEW',
    CONTACTED: 'CONTACTED',
    QUALIFIED: 'QUALIFIED',
    IN_NEGOTIATION: 'IN_NEGOTIATION',
    CONVERTED: 'CONVERTED',
    LOST: 'LOST',
};
export const LeadTemperature = {
    HOT: 'HOT',
    WARM: 'WARM',
    COLD: 'COLD',
    FROZEN: 'FROZEN',
};
export const LedgerEntryType = {
    CREDIT_PAYMENT: 'CREDIT_PAYMENT',
    FEE: 'FEE',
    TRANSFER_OUT: 'TRANSFER_OUT',
    REFUND: 'REFUND',
    CHARGEBACK: 'CHARGEBACK',
    SPLIT_IN: 'SPLIT_IN',
    SPLIT_OUT: 'SPLIT_OUT',
    ADJUSTMENT: 'ADJUSTMENT',
};
export const LetterheadMode = {
    BANDS: 'BANDS',
    FULL_PAGE: 'FULL_PAGE',
    RESERVE: 'RESERVE',
};
export const LetterheadPageSize = {
    A4: 'A4',
    A5: 'A5',
};
export const LetterheadWatermarkType = {
    NONE: 'NONE',
    TEXT: 'TEXT',
    IMAGE: 'IMAGE',
};
export const MaritalStatus = {
    SINGLE: 'SINGLE',
    MARRIED: 'MARRIED',
    DIVORCED: 'DIVORCED',
    WIDOWED: 'WIDOWED',
    STABLE_UNION: 'STABLE_UNION',
    OTHER: 'OTHER',
};
export const MarketingEventDestination = {
    META: 'META',
    GOOGLE_ADS: 'GOOGLE_ADS',
    TIKTOK: 'TIKTOK',
};
export const MarketingEventDispatchStatus = {
    SENT: 'SENT',
    FAILED: 'FAILED',
    SKIPPED: 'SKIPPED',
};
export const MarketingEventTrigger = {
    STAGE_ENTERED: 'STAGE_ENTERED',
    ORDER_FIRST_PAYMENT: 'ORDER_FIRST_PAYMENT',
    APPOINTMENT_SCHEDULED: 'APPOINTMENT_SCHEDULED',
    ORDER_SETTLED: 'ORDER_SETTLED',
    LEAD_CREATED: 'LEAD_CREATED',
    APPOINTMENT_CANCELLED: 'APPOINTMENT_CANCELLED',
};
export const MarketingEventValueSource = {
    NONE: 'NONE',
    ORDER_TOTAL: 'ORDER_TOTAL',
    BILLING_PAID_TOTAL: 'BILLING_PAID_TOTAL',
    DEAL_VALUE: 'DEAL_VALUE',
};
export const MedicalCertificateType = {
    SICK_LEAVE: 'SICK_LEAVE',
    FITNESS: 'FITNESS',
    ACCOMPANIMENT: 'ACCOMPANIMENT',
    SCHOOL: 'SCHOOL',
    SPORTS: 'SPORTS',
    TRAVEL: 'TRAVEL',
    WORK_RETURN: 'WORK_RETURN',
    CERTIFICATE_OTHER: 'CERTIFICATE_OTHER',
};
export const MedicalReportType = {
    CONSULTATION: 'CONSULTATION',
    EXAM_REPORT: 'EXAM_REPORT',
    PROCEDURE_REPORT: 'PROCEDURE_REPORT',
    DISCHARGE_SUMMARY: 'DISCHARGE_SUMMARY',
    EVOLUTION: 'EVOLUTION',
    CERTIFICATE: 'CERTIFICATE',
    REFERRAL: 'REFERRAL',
    OTHER: 'OTHER',
};
export const MedicalSpecialty = {
    GENERAL_PRACTICE: 'GENERAL_PRACTICE',
    CARDIOLOGY: 'CARDIOLOGY',
    DERMATOLOGY: 'DERMATOLOGY',
    ENDOCRINOLOGY: 'ENDOCRINOLOGY',
    GASTROENTEROLOGY: 'GASTROENTEROLOGY',
    GERIATRICS: 'GERIATRICS',
    GYNECOLOGY: 'GYNECOLOGY',
    OBSTETRICS: 'OBSTETRICS',
    HEMATOLOGY: 'HEMATOLOGY',
    NEPHROLOGY: 'NEPHROLOGY',
    NEUROLOGY: 'NEUROLOGY',
    ONCOLOGY: 'ONCOLOGY',
    OPHTHALMOLOGY: 'OPHTHALMOLOGY',
    ORTHOPEDICS: 'ORTHOPEDICS',
    OTOLARYNGOLOGY: 'OTOLARYNGOLOGY',
    PEDIATRICS: 'PEDIATRICS',
    PNEUMOLOGY: 'PNEUMOLOGY',
    PSYCHIATRY: 'PSYCHIATRY',
    RHEUMATOLOGY: 'RHEUMATOLOGY',
    UROLOGY: 'UROLOGY',
    ANESTHESIOLOGY: 'ANESTHESIOLOGY',
    RADIOLOGY: 'RADIOLOGY',
    PATHOLOGY: 'PATHOLOGY',
    EMERGENCY: 'EMERGENCY',
    INTENSIVE_CARE: 'INTENSIVE_CARE',
    SURGERY_GENERAL: 'SURGERY_GENERAL',
    SURGERY_CARDIOVASCULAR: 'SURGERY_CARDIOVASCULAR',
    SURGERY_PLASTIC: 'SURGERY_PLASTIC',
    SURGERY_VASCULAR: 'SURGERY_VASCULAR',
    PHYSICAL_THERAPY: 'PHYSICAL_THERAPY',
    NUTRITION: 'NUTRITION',
    PSYCHOLOGY: 'PSYCHOLOGY',
    SPEECH_THERAPY: 'SPEECH_THERAPY',
    OCCUPATIONAL_THERAPY: 'OCCUPATIONAL_THERAPY',
    DENTISTRY: 'DENTISTRY',
    OTHER: 'OTHER',
};
export const MedicalSupplyType = {
    OPME: 'OPME',
    PRODUCT: 'PRODUCT',
    DISPOSABLE_KIT: 'DISPOSABLE_KIT',
    INFECTION_PREVENTION_BUNDLE: 'INFECTION_PREVENTION_BUNDLE',
    PACKAGE: 'PACKAGE',
    SURGICAL_MATERIAL: 'SURGICAL_MATERIAL',
    INSTRUMENT: 'INSTRUMENT',
    IMPLANT: 'IMPLANT',
    EQUIPMENT: 'EQUIPMENT',
};
export const MedicationControlType = {
    COMMON: 'COMMON',
    CONTROLLED_A1: 'CONTROLLED_A1',
    CONTROLLED_A2: 'CONTROLLED_A2',
    CONTROLLED_A3: 'CONTROLLED_A3',
    CONTROLLED_B1: 'CONTROLLED_B1',
    CONTROLLED_B2: 'CONTROLLED_B2',
    CONTROLLED_C1: 'CONTROLLED_C1',
    CONTROLLED_C2: 'CONTROLLED_C2',
    CONTROLLED_C3: 'CONTROLLED_C3',
    CONTROLLED_C4: 'CONTROLLED_C4',
    CONTROLLED_C5: 'CONTROLLED_C5',
    ANTIMICROBIAL: 'ANTIMICROBIAL',
};
export const MedicationType = {
    MEDICATION: 'MEDICATION',
    VACCINE: 'VACCINE',
    MATERIAL: 'MATERIAL',
    SOLUTION: 'SOLUTION',
    DIET: 'DIET',
    CONTRAST: 'CONTRAST',
    BLOOD_DERIVATIVE: 'BLOOD_DERIVATIVE',
    OTHER: 'OTHER',
};
export const MedicationUnit = {
    UNIT: 'UNIT',
    AMPOULE: 'AMPOULE',
    VIAL: 'VIAL',
    TABLET: 'TABLET',
    CAPSULE: 'CAPSULE',
    ML: 'ML',
    MG: 'MG',
    DOSE: 'DOSE',
    KIT: 'KIT',
    BOX: 'BOX',
    PACK: 'PACK',
};
export const MessageRole = {
    user: 'user',
    assistant: 'assistant',
    company: 'company',
    tool: 'tool',
    system: 'system',
};
export const MetaConnectionAuthMode = {
    OAUTH: 'OAUTH',
    PARTNER: 'PARTNER',
    PIXEL_TOKEN: 'PIXEL_TOKEN',
};
export const MetaConnectionStatus = {
    PENDING: 'PENDING',
    ACTIVE: 'ACTIVE',
    EXPIRED: 'EXPIRED',
    REVOKED: 'REVOKED',
};
export const NegotiationModality = {
    SALE: 'SALE',
    RENTAL: 'RENTAL',
};
export const NotificationScope = {
    COMPANY: 'COMPANY',
    PERSONAL: 'PERSONAL',
};
export const NotificationTargetType = {
    ALL: 'ALL',
    MASTER: 'MASTER',
    ROLE: 'ROLE',
    COMPANY: 'COMPANY',
    USER: 'USER',
    EMPLOYEES: 'EMPLOYEES',
    PROFESSIONALS: 'PROFESSIONALS',
    CLIENTS: 'CLIENTS',
    PROFESSIONAL: 'PROFESSIONAL',
    CLIENT: 'CLIENT',
    PARTNER: 'PARTNER',
};
export const NotificationType = {
    INFO: 'INFO',
    SUCCESS: 'SUCCESS',
    WARNING: 'WARNING',
    ERROR: 'ERROR',
    SYSTEM: 'SYSTEM',
    ANNOUNCEMENT: 'ANNOUNCEMENT',
};
export const NursingShift = {
    SHIFT_MORNING: 'SHIFT_MORNING',
    SHIFT_AFTERNOON: 'SHIFT_AFTERNOON',
    SHIFT_NIGHT: 'SHIFT_NIGHT',
    SHIFT_FULL_DAY: 'SHIFT_FULL_DAY',
    SHIFT_FULL_NIGHT: 'SHIFT_FULL_NIGHT',
};
export const OnboardingProfile = {
    CLINIC: 'CLINIC',
    INDIVIDUAL_DOCTOR: 'INDIVIDUAL_DOCTOR',
};
export const OrderOrigin = {
    ADMIN: 'ADMIN',
    STORE: 'STORE',
    AI: 'AI',
    COUNTER: 'COUNTER',
};
export const OrderShippingKind = {
    DELIVERY: 'DELIVERY',
    PICKUP: 'PICKUP',
};
export const OrderStatus = {
    BUDGET: 'BUDGET',
    SCHEDULED: 'SCHEDULED',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
    POSTPONED: 'POSTPONED',
};
export const OutputSource = {
    OUTPUT_URINE: 'OUTPUT_URINE',
    OUTPUT_URINE_CATHETER: 'OUTPUT_URINE_CATHETER',
    OUTPUT_VOMIT: 'OUTPUT_VOMIT',
    OUTPUT_GASTRIC_DRAINAGE: 'OUTPUT_GASTRIC_DRAINAGE',
    OUTPUT_SURGICAL_DRAINAGE: 'OUTPUT_SURGICAL_DRAINAGE',
    OUTPUT_CHEST_DRAINAGE: 'OUTPUT_CHEST_DRAINAGE',
    OUTPUT_FECES: 'OUTPUT_FECES',
    OUTPUT_DIARRHEA: 'OUTPUT_DIARRHEA',
    OUTPUT_BLEEDING: 'OUTPUT_BLEEDING',
    OUTPUT_WOUND_DRAINAGE: 'OUTPUT_WOUND_DRAINAGE',
    OUTPUT_PERSPIRATION: 'OUTPUT_PERSPIRATION',
    OUTPUT_INSENSIBLE_LOSS: 'OUTPUT_INSENSIBLE_LOSS',
    OUTPUT_DIALYSIS: 'OUTPUT_DIALYSIS',
    OUTPUT_OTHER: 'OUTPUT_OTHER',
};
export const PaidTrafficChannel = {
    META: 'META',
    GOOGLE: 'GOOGLE',
    TIKTOK: 'TIKTOK',
    CAMPAIGN: 'CAMPAIGN',
};
export const PartnerInquiryStatus = {
    PENDING: 'PENDING',
    RESPONDED: 'RESPONDED',
    RELAYED: 'RELAYED',
    CONFIRMED: 'CONFIRMED',
    REJECTED: 'REJECTED',
    EXPIRED: 'EXPIRED',
    CANCELED: 'CANCELED',
};
export const PartnerPayoutScheduleType = {
    OPEN: 'OPEN',
    FIXED_DAY: 'FIXED_DAY',
    DAYS_AFTER_APPOINTMENT: 'DAYS_AFTER_APPOINTMENT',
};
export const PaymentAccountStatus = {
    PENDING_KYC: 'PENDING_KYC',
    ACTIVE: 'ACTIVE',
    BLOCKED: 'BLOCKED',
    CLOSED: 'CLOSED',
};
export const PaymentBillingType = {
    CREDIT_CARD: 'CREDIT_CARD',
    PIX: 'PIX',
    BOLETO: 'BOLETO',
    DEBIT_CARD: 'DEBIT_CARD',
};
export const PaymentStatus = {
    PENDING: 'PENDING',
    RECEIVED: 'RECEIVED',
    CONFIRMED: 'CONFIRMED',
    OVERDUE: 'OVERDUE',
    REFUNDED: 'REFUNDED',
    RECEIVED_IN_CASH: 'RECEIVED_IN_CASH',
    CHARGEBACK_REQUESTED: 'CHARGEBACK_REQUESTED',
    CHARGEBACK_DISPUTE: 'CHARGEBACK_DISPUTE',
    AWAITING_CHARGEBACK_REVERSAL: 'AWAITING_CHARGEBACK_REVERSAL',
    DUNNING_REQUESTED: 'DUNNING_REQUESTED',
    DUNNING_RECEIVED: 'DUNNING_RECEIVED',
    AWAITING_RISK_ANALYSIS: 'AWAITING_RISK_ANALYSIS',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
};
export const PaymentType = {
    PAYMENT_PRIVATE: 'PAYMENT_PRIVATE',
    PAYMENT_INSURANCE: 'PAYMENT_INSURANCE',
    PAYMENT_MIXED: 'PAYMENT_MIXED',
    PAYMENT_COURTESY: 'PAYMENT_COURTESY',
    PAYMENT_SOCIAL: 'PAYMENT_SOCIAL',
};
export const PersonalHistoryCategory = {
    CARDIOVASCULAR: 'CARDIOVASCULAR',
    RESPIRATORY: 'RESPIRATORY',
    NEUROLOGICAL: 'NEUROLOGICAL',
    ENDOCRINE: 'ENDOCRINE',
    GASTROINTESTINAL: 'GASTROINTESTINAL',
    RENAL: 'RENAL',
    HEPATIC: 'HEPATIC',
    MUSCULOSKELETAL: 'MUSCULOSKELETAL',
    DERMATOLOGICAL: 'DERMATOLOGICAL',
    PSYCHIATRIC: 'PSYCHIATRIC',
    ONCOLOGICAL: 'ONCOLOGICAL',
    INFECTIOUS: 'INFECTIOUS',
    AUTOIMMUNE: 'AUTOIMMUNE',
    SURGICAL: 'SURGICAL',
    HOSPITALIZATION: 'HOSPITALIZATION',
    TRAUMA: 'TRAUMA',
    GYNECOLOGICAL: 'GYNECOLOGICAL',
    OBSTETRIC: 'OBSTETRIC',
    VACCINATION: 'VACCINATION',
    TRANSFUSION: 'TRANSFUSION',
    OTHER: 'OTHER',
};
export const PersonType = {
    FISICA: 'FISICA',
    JURIDICA: 'JURIDICA',
};
export const PharmacyIntegrationType = {
    MEMED: 'MEMED',
    NEXODATA: 'NEXODATA',
    CUSTOM_API: 'CUSTOM_API',
};
export const PipelineType = {
    ACQUISITION: 'ACQUISITION',
    RETENTION: 'RETENTION',
    UPSELL: 'UPSELL',
    CUSTOM: 'CUSTOM',
};
export const PolicyStatus = {
    PUBLISHED: 'PUBLISHED',
    DRAFT: 'DRAFT',
    IN_ANALYSIS: 'IN_ANALYSIS',
    INACTIVE: 'INACTIVE',
};
export const PolicyType = {
    TERMS_OF_SERVICE: 'TERMS_OF_SERVICE',
    PRIVACY_POLICY: 'PRIVACY_POLICY',
    COOKIE_POLICY: 'COOKIE_POLICY',
    LGPD_PRIVACY_NOTICE: 'LGPD_PRIVACY_NOTICE',
    GDPR_POLICY: 'GDPR_POLICY',
    CCPA_POLICY: 'CCPA_POLICY',
    DATA_CONSENT_DECLARATION: 'DATA_CONSENT_DECLARATION',
    NDA: 'NDA',
    SECURITY_POLICY: 'SECURITY_POLICY',
    SERVICE_CONTRACT: 'SERVICE_CONTRACT',
    CODE_OF_CONDUCT: 'CODE_OF_CONDUCT',
    DATA_RETENTION_DISPOSAL_POLICY: 'DATA_RETENTION_DISPOSAL_POLICY',
    REFUND_POLICY: 'REFUND_POLICY',
    RETURN_POLICY: 'RETURN_POLICY',
    SHIPPING_POLICY: 'SHIPPING_POLICY',
    CANCELLATION_POLICY: 'CANCELLATION_POLICY',
    PAYMENT_POLICY: 'PAYMENT_POLICY',
    SUBSCRIPTION_POLICY: 'SUBSCRIPTION_POLICY',
    ACCEPTABLE_USE_POLICY: 'ACCEPTABLE_USE_POLICY',
    COMMUNITY_GUIDELINES: 'COMMUNITY_GUIDELINES',
    DISCLAIMER: 'DISCLAIMER',
    END_USER_LICENSE_AGREEMENT: 'END_USER_LICENSE_AGREEMENT',
    COPYRIGHT_POLICY: 'COPYRIGHT_POLICY',
    TRADEMARK_POLICY: 'TRADEMARK_POLICY',
    THIRD_PARTY_POLICY: 'THIRD_PARTY_POLICY',
    MARKETING_POLICY: 'MARKETING_POLICY',
    EMPLOYEE_PRIVACY_POLICY: 'EMPLOYEE_PRIVACY_POLICY',
    INTERNAL_USE_POLICY: 'INTERNAL_USE_POLICY',
    OTHER: 'OTHER',
};
export const PrescriptionItemStatus = {
    ITEM_PENDING: 'ITEM_PENDING',
    ITEM_SCHEDULED: 'ITEM_SCHEDULED',
    ITEM_ADMINISTERED: 'ITEM_ADMINISTERED',
    ITEM_PARTIALLY: 'ITEM_PARTIALLY',
    ITEM_NOT_ADMINISTERED: 'ITEM_NOT_ADMINISTERED',
    ITEM_SUSPENDED: 'ITEM_SUSPENDED',
    ITEM_CANCELLED: 'ITEM_CANCELLED',
};
export const PresenceEventType = {
    ARRIVED: 'ARRIVED',
    STATUS_CHANGED: 'STATUS_CHANGED',
    ROOM_CHANGED: 'ROOM_CHANGED',
    FINISHED: 'FINISHED',
};
export const PriceTableStatus = {
    PRICE_TABLE_ACTIVE: 'PRICE_TABLE_ACTIVE',
    PRICE_TABLE_INACTIVE: 'PRICE_TABLE_INACTIVE',
    PRICE_TABLE_PENDING_APPROVAL: 'PRICE_TABLE_PENDING_APPROVAL',
    PRICE_TABLE_EXPIRED: 'PRICE_TABLE_EXPIRED',
};
export const PriceTableType = {
    PROCEDURE: 'PROCEDURE',
    CONSULTATION: 'CONSULTATION',
    EXAM: 'EXAM',
    MATERIAL: 'MATERIAL',
    MEDICATION: 'MEDICATION',
    FEE: 'FEE',
    PACKAGE: 'PACKAGE',
};
export const PriceType = {
    FIXED: 'FIXED',
    VARIABLE: 'VARIABLE',
    FROM: 'FROM',
    FREE: 'FREE',
    NEGOTIABLE: 'NEGOTIABLE',
};
export const ProductOrigin = {
    NATIONAL: 'NATIONAL',
    IMPORTED: 'IMPORTED',
    IMPORTED_NATIONAL_CONTENT: 'IMPORTED_NATIONAL_CONTENT',
    NATIONAL_IMPORTED_CONTENT: 'NATIONAL_IMPORTED_CONTENT',
};
export const ProductUnit = {
    UNIT: 'UNIT',
    KG: 'KG',
    GRAM: 'GRAM',
    LITER: 'LITER',
    ML: 'ML',
    METER: 'METER',
    CM: 'CM',
    HOUR: 'HOUR',
    SESSION: 'SESSION',
    PACK: 'PACK',
    BOX: 'BOX',
    PAIR: 'PAIR',
    DOZEN: 'DOZEN',
};
export const PromotionType = {
    ALL_STORE: 'ALL_STORE',
    CATEGORY: 'CATEGORY',
    SUBCATEGORY: 'SUBCATEGORY',
    MINIMUM_PURCHASE: 'MINIMUM_PURCHASE',
    SPECIFIC_PRODUCTS: 'SPECIFIC_PRODUCTS',
};
export const PushPlatform = {
    WEB: 'WEB',
    ANDROID: 'ANDROID',
    IOS: 'IOS',
};
export const QueueStatus = {
    PENDING: 'PENDING',
    PROCESSING: 'PROCESSING',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
};
export const QuickMessageVisibility = {
    PRIVATE: 'PRIVATE',
    COMPANY: 'COMPANY',
    ORGANIZATION: 'ORGANIZATION',
};
export const RankingPeriod = {
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    QUARTERLY: 'QUARTERLY',
    ALL_TIME: 'ALL_TIME',
};
export const Recurrence = {
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY',
    SEMIANNUAL: 'SEMIANNUAL',
};
export const RecurringFrequency = {
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    BIWEEKLY: 'BIWEEKLY',
    MONTHLY: 'MONTHLY',
    QUARTERLY: 'QUARTERLY',
    SEMIANNUAL: 'SEMIANNUAL',
    ANNUAL: 'ANNUAL',
};
export const RecurringPurchaseStatus = {
    ACTIVE: 'ACTIVE',
    PAUSED: 'PAUSED',
    CANCELLED: 'CANCELLED',
};
export const ReferralStatus = {
    REFERRAL_PENDING: 'REFERRAL_PENDING',
    REFERRAL_SCHEDULED: 'REFERRAL_SCHEDULED',
    REFERRAL_IN_PROGRESS: 'REFERRAL_IN_PROGRESS',
    REFERRAL_COMPLETED: 'REFERRAL_COMPLETED',
    REFERRAL_CANCELLED: 'REFERRAL_CANCELLED',
    REFERRAL_NO_SHOW: 'REFERRAL_NO_SHOW',
};
export const ReferralUrgency = {
    ROUTINE: 'ROUTINE',
    REFERRAL_PRIORITY: 'REFERRAL_PRIORITY',
    REFERRAL_URGENT: 'REFERRAL_URGENT',
    REFERRAL_EMERGENCY: 'REFERRAL_EMERGENCY',
};
export const ReportAutomationFormat = {
    PDF: 'PDF',
    XLSX: 'XLSX',
    CSV: 'CSV',
};
export const ReportAutomationFrequency = {
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
};
export const ReportAutomationPeriod = {
    TODAY: 'TODAY',
    YESTERDAY: 'YESTERDAY',
    LAST_7_DAYS: 'LAST_7_DAYS',
    LAST_30_DAYS: 'LAST_30_DAYS',
    THIS_WEEK: 'THIS_WEEK',
    LAST_WEEK: 'LAST_WEEK',
    THIS_MONTH: 'THIS_MONTH',
    LAST_MONTH: 'LAST_MONTH',
    THIS_YEAR: 'THIS_YEAR',
};
export const RndsEventType = {
    IMMUNIZATION: 'IMMUNIZATION',
    LAB_RESULT: 'LAB_RESULT',
    SUMMARY: 'SUMMARY',
    RNDS_PRESCRIPTION: 'RNDS_PRESCRIPTION',
    ALLERGY_INTOLERANCE: 'ALLERGY_INTOLERANCE',
    CONDITION: 'CONDITION',
};
export const RndsStatus = {
    RNDS_PENDING: 'RNDS_PENDING',
    RNDS_SENDING: 'RNDS_SENDING',
    RNDS_SENT: 'RNDS_SENT',
    RNDS_ACKNOWLEDGED: 'RNDS_ACKNOWLEDGED',
    RNDS_ERROR: 'RNDS_ERROR',
    RNDS_REJECTED: 'RNDS_REJECTED',
};
export const SalesFlowNodeType = {
    START: 'START',
    SEND_WHATSAPP: 'SEND_WHATSAPP',
    SEND_TEMPLATE: 'SEND_TEMPLATE',
    SEND_EMAIL: 'SEND_EMAIL',
    NOTIFY_USER: 'NOTIFY_USER',
    PAUSE: 'PAUSE',
    CONDITION: 'CONDITION',
    MOVE_STAGE: 'MOVE_STAGE',
    ASSIGN_USER: 'ASSIGN_USER',
    ASSIGN_WALLET: 'ASSIGN_WALLET',
    SET_FIELD: 'SET_FIELD',
    TAG: 'TAG',
    SET_TEMPERATURE: 'SET_TEMPERATURE',
    SET_LIFECYCLE: 'SET_LIFECYCLE',
    CREATE_DEAL: 'CREATE_DEAL',
    ADD_NOTE: 'ADD_NOTE',
    CREATE_TASK: 'CREATE_TASK',
    WEBHOOK: 'WEBHOOK',
    GO_TO: 'GO_TO',
    START_FLOW: 'START_FLOW',
    STOP: 'STOP',
};
export const SalesFlowRunStatus = {
    RUNNING: 'RUNNING',
    WAITING: 'WAITING',
    COMPLETED: 'COMPLETED',
    STOPPED: 'STOPPED',
    CANCELLED: 'CANCELLED',
    FAILED: 'FAILED',
};
export const SalesFlowTriggerType = {
    EVENT: 'EVENT',
    STAGE_ENTERED: 'STAGE_ENTERED',
    TIME_IN_STAGE: 'TIME_IN_STAGE',
    DATE_FIELD_OFFSET: 'DATE_FIELD_OFFSET',
    NO_REPLY: 'NO_REPLY',
    INBOUND_AFTER_SILENCE: 'INBOUND_AFTER_SILENCE',
    OUTBOUND_READ: 'OUTBOUND_READ',
    CONVERSATION_CLOSED: 'CONVERSATION_CLOSED',
    SCHEDULE_DAILY: 'SCHEDULE_DAILY',
    MANUAL: 'MANUAL',
};
export const SalesFlowWaitKind = {
    TIMER: 'TIMER',
    REPLY: 'REPLY',
    WINDOW: 'WINDOW',
    RATE_LIMIT: 'RATE_LIMIT',
};
export const SalesGoalPeriod = {
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    QUARTERLY: 'QUARTERLY',
    YEARLY: 'YEARLY',
    CUSTOM: 'CUSTOM',
};
export const SalesGoalScope = {
    INDIVIDUAL: 'INDIVIDUAL',
    WALLET: 'WALLET',
    COMPANY: 'COMPANY',
};
export const SalesGoalStatus = {
    ACTIVE: 'ACTIVE',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
    CANCELLED: 'CANCELLED',
};
export const SalesGoalType = {
    REVENUE: 'REVENUE',
    DEALS_WON: 'DEALS_WON',
    DEALS_CREATED: 'DEALS_CREATED',
    LEADS_CONVERTED: 'LEADS_CONVERTED',
    AVG_CLOSE_TIME: 'AVG_CLOSE_TIME',
    CONVERSION_RATE: 'CONVERSION_RATE',
    FOLLOW_UPS_SENT: 'FOLLOW_UPS_SENT',
    ACTIVITIES: 'ACTIVITIES',
};
export const ScheduleType = {
    FIXED_INTERVAL: 'FIXED_INTERVAL',
    FIXED_TIMES: 'FIXED_TIMES',
    AS_NEEDED: 'AS_NEEDED',
    CONTINUOUS: 'CONTINUOUS',
    SINGLE_DOSE: 'SINGLE_DOSE',
    BEFORE_MEALS: 'BEFORE_MEALS',
    AFTER_MEALS: 'AFTER_MEALS',
    FASTING: 'FASTING',
    BEDTIME: 'BEDTIME',
    UPON_WAKING: 'UPON_WAKING',
};
export const ScholarLevel = {
    FUNDAMENTAL: 'FUNDAMENTAL',
    MEDIO: 'MEDIO',
    TECNICO: 'TECNICO',
    SUPERIOR: 'SUPERIOR',
    POS_GRADUACAO: 'POS_GRADUACAO',
    MESTRADO: 'MESTRADO',
    DOUTORADO: 'DOUTORADO',
    POS_DOUTORADO: 'POS_DOUTORADO',
};
export const ServiceAddressSource = {
    PARTNER: 'PARTNER',
    PROFESSIONAL: 'PROFESSIONAL',
    HOSPITAL: 'HOSPITAL',
    CUSTOM: 'CUSTOM',
    UNCONFIRMED: 'UNCONFIRMED',
};
export const ServicePaymentStatus = {
    SERVICE_PENDING_DEFINITION: 'SERVICE_PENDING_DEFINITION',
    SERVICE_PENDING_AUTHORIZATION: 'SERVICE_PENDING_AUTHORIZATION',
    SERVICE_PENDING_PAYMENT: 'SERVICE_PENDING_PAYMENT',
    SERVICE_PARTIAL_PAYMENT: 'SERVICE_PARTIAL_PAYMENT',
    SERVICE_PAID: 'SERVICE_PAID',
    SERVICE_BILLED_INSURANCE: 'SERVICE_BILLED_INSURANCE',
    SERVICE_CANCELLED: 'SERVICE_CANCELLED',
};
export const SettingRole = {
    MASTER: 'MASTER',
    COMPANY: 'COMPANY',
    SYSTEM: 'SYSTEM',
    CLIENT: 'CLIENT',
    USER: 'USER',
    PROFESSIONAL: 'PROFESSIONAL',
};
export const ShippingPaymentMode = {
    CUSTOMER: 'CUSTOMER',
    STORE: 'STORE',
    SUBSIDIZED: 'SUBSIDIZED',
    FLAT_RATE: 'FLAT_RATE',
};
export const SignDocumentStatus = {
    PENDING: 'PENDING',
    SENT: 'SENT',
    SIGNING: 'SIGNING',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
};
export const SLAType = {
    FIRST_RESPONSE: 'FIRST_RESPONSE',
    STAGE_TIME: 'STAGE_TIME',
    NO_ACTIVITY: 'NO_ACTIVITY',
    TASK_OVERDUE: 'TASK_OVERDUE',
};
export const SngpcMovementType = {
    SNGPC_PURCHASE: 'SNGPC_PURCHASE',
    SNGPC_SALE: 'SNGPC_SALE',
    SNGPC_TRANSFER_IN: 'SNGPC_TRANSFER_IN',
    SNGPC_TRANSFER_OUT: 'SNGPC_TRANSFER_OUT',
    SNGPC_LOSS: 'SNGPC_LOSS',
    SNGPC_THEFT: 'SNGPC_THEFT',
    SNGPC_RETURN_SUPPLIER: 'SNGPC_RETURN_SUPPLIER',
    SNGPC_RETURN_CUSTOMER: 'SNGPC_RETURN_CUSTOMER',
    SNGPC_TRANSFORMATION: 'SNGPC_TRANSFORMATION',
    SNGPC_DESTRUCTION: 'SNGPC_DESTRUCTION',
    SNGPC_LENDING: 'SNGPC_LENDING',
    SNGPC_ADJUSTMENT: 'SNGPC_ADJUSTMENT',
};
export const SngpcTransmissionStatus = {
    SNGPC_PENDING: 'SNGPC_PENDING',
    SNGPC_TRANSMITTED: 'SNGPC_TRANSMITTED',
    SNGPC_ACCEPTED: 'SNGPC_ACCEPTED',
    SNGPC_REJECTED: 'SNGPC_REJECTED',
    SNGPC_ERROR: 'SNGPC_ERROR',
};
export const StockMovementType = {
    STOCK_ENTRY: 'STOCK_ENTRY',
    STOCK_EXIT: 'STOCK_EXIT',
    STOCK_ADJUSTMENT_POSITIVE: 'STOCK_ADJUSTMENT_POSITIVE',
    STOCK_ADJUSTMENT_NEGATIVE: 'STOCK_ADJUSTMENT_NEGATIVE',
    STOCK_TRANSFER_IN: 'STOCK_TRANSFER_IN',
    STOCK_TRANSFER_OUT: 'STOCK_TRANSFER_OUT',
    STOCK_LOSS: 'STOCK_LOSS',
    STOCK_EXPIRATION: 'STOCK_EXPIRATION',
    STOCK_RETURN: 'STOCK_RETURN',
    STOCK_RECALL: 'STOCK_RECALL',
    STOCK_INVENTORY: 'STOCK_INVENTORY',
};
export const StorageAccessPrincipal = {
    USER: 'USER',
    ROLE: 'ROLE',
    DEPARTMENT: 'DEPARTMENT',
};
export const StorageAuditAction = {
    VIEW: 'VIEW',
    DOWNLOAD: 'DOWNLOAD',
    UPLOAD: 'UPLOAD',
    RENAME: 'RENAME',
    MOVE: 'MOVE',
    DELETE: 'DELETE',
    RESTORE: 'RESTORE',
    PURGE: 'PURGE',
    SHARE_CREATE: 'SHARE_CREATE',
    SHARE_ACCESS: 'SHARE_ACCESS',
    SHARE_REVOKE: 'SHARE_REVOKE',
    PASSWORD_OK: 'PASSWORD_OK',
    PASSWORD_FAIL: 'PASSWORD_FAIL',
    VERSION_RESTORE: 'VERSION_RESTORE',
};
export const StorageScanStatus = {
    PENDING: 'PENDING',
    CLEAN: 'CLEAN',
    INFECTED: 'INFECTED',
    SKIPPED: 'SKIPPED',
};
export const StorageTemperature = {
    AMBIENT: 'AMBIENT',
    REFRIGERATED: 'REFRIGERATED',
    FROZEN: 'FROZEN',
    DEEP_FROZEN: 'DEEP_FROZEN',
    CONTROLLED_AMBIENT: 'CONTROLLED_AMBIENT',
};
export const StorageTier = {
    HOT: 'HOT',
    ARCHIVE: 'ARCHIVE',
};
export const StorageVisibility = {
    PRIVATE: 'PRIVATE',
    COMPANY: 'COMPANY',
    ORGANIZATION: 'ORGANIZATION',
    CUSTOM: 'CUSTOM',
};
export const StoreCollectionKind = {
    MANUAL: 'MANUAL',
    CATEGORY: 'CATEGORY',
    ON_SALE: 'ON_SALE',
    NEWEST: 'NEWEST',
    BEST_SELLING: 'BEST_SELLING',
};
export const StoreNewsletterFrequency = {
    OFF: 'OFF',
    WEEKLY: 'WEEKLY',
    BIWEEKLY: 'BIWEEKLY',
    MONTHLY: 'MONTHLY',
};
export const StoreNewsletterStatus = {
    SUBSCRIBED: 'SUBSCRIBED',
    UNSUBSCRIBED: 'UNSUBSCRIBED',
};
export const StoreWidgetType = {
    HTML: 'HTML',
    JAVASCRIPT: 'JAVASCRIPT',
};
export const SubscriptionOrigin = {
    COMPANY: 'COMPANY',
    RESELLER: 'RESELLER',
};
export const SubscriptionStatus = {
    ACTIVE: 'ACTIVE',
    CANCELLED: 'CANCELLED',
    SUSPENDED: 'SUSPENDED',
};
export const SystemAnnouncementKind = {
    INFO: 'INFO',
    WARNING: 'WARNING',
    MAINTENANCE: 'MAINTENANCE',
    RELEASE: 'RELEASE',
};
export const TeleconsultationParticipantRole = {
    PROFESSIONAL: 'PROFESSIONAL',
    PATIENT: 'PATIENT',
};
export const TeleconsultationStatus = {
    CREATED: 'CREATED',
    WAITING_PATIENT: 'WAITING_PATIENT',
    WAITING_DOCTOR: 'WAITING_DOCTOR',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
    EXPIRED: 'EXPIRED',
};
export const TemperatureAlertStatus = {
    ALERT_ACTIVE: 'ALERT_ACTIVE',
    ALERT_ACKNOWLEDGED: 'ALERT_ACKNOWLEDGED',
    ALERT_RESOLVED: 'ALERT_RESOLVED',
    ALERT_ESCALATED: 'ALERT_ESCALATED',
};
export const TemperatureAlertType = {
    TEMP_BELOW_MINIMUM: 'TEMP_BELOW_MINIMUM',
    TEMP_ABOVE_MAXIMUM: 'TEMP_ABOVE_MAXIMUM',
    TEMP_SENSOR_FAILURE: 'TEMP_SENSOR_FAILURE',
    TEMP_POWER_OUTAGE: 'TEMP_POWER_OUTAGE',
    TEMP_DOOR_OPEN: 'TEMP_DOOR_OPEN',
};
export const TemplateCategory = {
    EXAM_REQUEST: 'EXAM_REQUEST',
    REPORT: 'REPORT',
    CERTIFICATE: 'CERTIFICATE',
    PRESCRIPTION: 'PRESCRIPTION',
};
export const TikTokConnectionStatus = {
    ACTIVE: 'ACTIVE',
    EXPIRED: 'EXPIRED',
    REVOKED: 'REVOKED',
};
export const TimelineEventType = {
    TIMELINE_CONSULTATION: 'TIMELINE_CONSULTATION',
    TIMELINE_TRIAGE: 'TIMELINE_TRIAGE',
    TIMELINE_EVOLUTION: 'TIMELINE_EVOLUTION',
    TIMELINE_PRESCRIPTION: 'TIMELINE_PRESCRIPTION',
    TIMELINE_EXAM_REQUEST: 'TIMELINE_EXAM_REQUEST',
    TIMELINE_EXAM_RESULT: 'TIMELINE_EXAM_RESULT',
    TIMELINE_PROCEDURE: 'TIMELINE_PROCEDURE',
    TIMELINE_DIAGNOSIS: 'TIMELINE_DIAGNOSIS',
    TIMELINE_ALLERGY_REGISTERED: 'TIMELINE_ALLERGY_REGISTERED',
    TIMELINE_REFERRAL: 'TIMELINE_REFERRAL',
    TIMELINE_CERTIFICATE: 'TIMELINE_CERTIFICATE',
    TIMELINE_REPORT: 'TIMELINE_REPORT',
    TIMELINE_DOCUMENT_SIGNED: 'TIMELINE_DOCUMENT_SIGNED',
    TIMELINE_HOSPITALIZATION: 'TIMELINE_HOSPITALIZATION',
    TIMELINE_DISCHARGE: 'TIMELINE_DISCHARGE',
    TIMELINE_VACCINATION: 'TIMELINE_VACCINATION',
    TIMELINE_NOTE: 'TIMELINE_NOTE',
};
export const TissGuideType = {
    SP_SADT: 'SP_SADT',
    CONSULTATION: 'CONSULTATION',
    HOSPITALIZATION: 'HOSPITALIZATION',
    HOSPITALIZATION_EXTENSION: 'HOSPITALIZATION_EXTENSION',
    DENTAL: 'DENTAL',
    FEES: 'FEES',
};
export const TissStatus = {
    TISS_PENDING: 'TISS_PENDING',
    TISS_SENT: 'TISS_SENT',
    TISS_AUTHORIZED: 'TISS_AUTHORIZED',
    TISS_PARTIALLY_AUTHORIZED: 'TISS_PARTIALLY_AUTHORIZED',
    TISS_DENIED: 'TISS_DENIED',
    TISS_CANCELLED: 'TISS_CANCELLED',
    TISS_PROCESSED: 'TISS_PROCESSED',
    TISS_ERROR: 'TISS_ERROR',
};
export const TissTransactionType = {
    ELIGIBILITY_CHECK: 'ELIGIBILITY_CHECK',
    AUTHORIZATION_REQUEST: 'AUTHORIZATION_REQUEST',
    GUIDE_SUBMISSION: 'GUIDE_SUBMISSION',
    GUIDE_CANCELLATION: 'GUIDE_CANCELLATION',
    BILLING: 'BILLING',
    PAYMENT_RESPONSE: 'PAYMENT_RESPONSE',
    DEMONSTRATION: 'DEMONSTRATION',
};
export const TranscriptionStatus = {
    PENDING: 'PENDING',
    PROCESSING: 'PROCESSING',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
};
export const TransferStatus = {
    TRANSFER_PENDING: 'TRANSFER_PENDING',
    TRANSFER_AUTHORIZED: 'TRANSFER_AUTHORIZED',
    TRANSFER_EXECUTED: 'TRANSFER_EXECUTED',
    TRANSFER_CANCELLED: 'TRANSFER_CANCELLED',
};
export const TransferType = {
    INTERNAL: 'INTERNAL',
    EXTERNAL: 'EXTERNAL',
    SECTOR: 'SECTOR',
};
export const TriageUrgency = {
    RED: 'RED',
    ORANGE: 'ORANGE',
    YELLOW: 'YELLOW',
    GREEN: 'GREEN',
    BLUE: 'BLUE',
};
export const TussSource = {
    IMPORTED: 'IMPORTED',
    MANUAL: 'MANUAL',
};
export const UserCommissionMode = {
    FIXED: 'FIXED',
    PERCENTAGE: 'PERCENTAGE',
};
export const UserType = {
    CLIENT: 'CLIENT',
    COMPANY: 'COMPANY',
    CUSTOM: 'CUSTOM',
    EMPLOYEE: 'EMPLOYEE',
    MASTER: 'MASTER',
    PARTNER: 'PARTNER',
    PROFESSIONAL: 'PROFESSIONAL',
};
export const VitalSignsSource = {
    VITAL_MANUAL: 'VITAL_MANUAL',
    VITAL_MONITOR: 'VITAL_MONITOR',
    VITAL_WEARABLE: 'VITAL_WEARABLE',
    VITAL_IOT: 'VITAL_IOT',
};
export const WaitingListStatus = {
    WAITING: 'WAITING',
    NOTIFIED: 'NOTIFIED',
    SCHEDULED: 'SCHEDULED',
    CANCELLED: 'CANCELLED',
    EXPIRED: 'EXPIRED',
};
export const WalletDistributionMode = {
    ROUND_ROBIN: 'ROUND_ROBIN',
    MANUAL: 'MANUAL',
    LOAD_BALANCED: 'LOAD_BALANCED',
};
export const WalletLeadCategory = {
    CONSULTATION: 'CONSULTATION',
    PROCEDURE: 'PROCEDURE',
    EXAM: 'EXAM',
    SALE: 'SALE',
};
export const WhatsappAccountStatus = {
    PENDING: 'PENDING',
    ACTIVE: 'ACTIVE',
    ERROR: 'ERROR',
};
export const WhatsappBroadcastRecipientStatus = {
    PENDING: 'PENDING',
    SENT: 'SENT',
    SKIPPED: 'SKIPPED',
    FAILED: 'FAILED',
};
export const WhatsappBroadcastStatus = {
    DRAFT: 'DRAFT',
    RUNNING: 'RUNNING',
    PAUSED: 'PAUSED',
    COMPLETED: 'COMPLETED',
    CANCELED: 'CANCELED',
};
export const WhatsappProviderKind = {
    WHATSAPP_API: 'WHATSAPP_API',
    WHATSAPP_WEB: 'WHATSAPP_WEB',
};
export const WhatsappSessionStatus = {
    DISCONNECTED: 'DISCONNECTED',
    PENDING_QR: 'PENDING_QR',
    CONNECTING: 'CONNECTING',
    CONNECTED: 'CONNECTED',
    LOGGED_OUT: 'LOGGED_OUT',
};
export const WhatsappSystemTemplateStatus = {
    DRAFT: 'DRAFT',
    PUBLISHED: 'PUBLISHED',
    RETIRED: 'RETIRED',
};
export const WhatsappTemplateApprovalStatus = {
    DRAFT: 'DRAFT',
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
    PAUSED: 'PAUSED',
    DISABLED: 'DISABLED',
};
export const WhatsappTemplateCategory = {
    MARKETING: 'MARKETING',
    UTILITY: 'UTILITY',
    AUTHENTICATION: 'AUTHENTICATION',
};
export const WhatsappTemplateContentType = {
    TEXT: 'TEXT',
    MEDIA: 'MEDIA',
    QUICK_REPLY: 'QUICK_REPLY',
    CALL_TO_ACTION: 'CALL_TO_ACTION',
    CARD: 'CARD',
};
export const WhatToDoWithTheResponse = {
    USE_TO_ANSWER_CLIENT: 'USE_TO_ANSWER_CLIENT',
    SAVE_IN_CHAT: 'SAVE_IN_CHAT',
    CALL_EXTERNAL_API: 'CALL_EXTERNAL_API',
};
export const WidgetPage = {
    HOME: 'HOME',
    PRODUCT_LIST: 'PRODUCT_LIST',
    PRODUCT_DETAIL: 'PRODUCT_DETAIL',
    ALL: 'ALL',
};
export const WidgetPosition = {
    HEADER: 'HEADER',
    SIDEBAR: 'SIDEBAR',
    BEFORE_CONTENT: 'BEFORE_CONTENT',
    AFTER_CONTENT: 'AFTER_CONTENT',
    FOOTER: 'FOOTER',
    BEFORE_PRODUCT_INFO: 'BEFORE_PRODUCT_INFO',
    AFTER_PRODUCT_INFO: 'AFTER_PRODUCT_INFO',
};
//# sourceMappingURL=prisma-enums.js.map